<template>     
    <TablePricesComponent :key="reloadComponent">
        <template #buttons>
            <Button v-if="listas && listas.length > 0" @click="showModal('cargarPrecios')" class="mb-1 mb-md-0">Cargar precios de una temporada anterior</Button>
            <CargarPrecios v-if="listas && listas.length > 0" :listas="listas" @close="closeModal" @preciosCargados="getTipos()" />
            <router-link :to="{ name: 'back.abonos.precios.grupos' }" class="btn btn-primary ml-3 mr-3 pt-2 mb-1 mb-md-0">Agrupar precios</router-link>
            <router-link :to="{ name: 'back.frecuencias' }" class="btn btn-primary mr-3 pt-2 mb-1 mb-md-0" target="blank">Frecuencias pago a plazos</router-link>
            <Button @click="showModal('crearPrecio')">Crear nuevo tipo de abono</Button>
            <CreatePrecioModal :lista_id="lista_id" @close="closeModal" />
        </template>
        <template #configurar-zonas="{ tipos }">
            <MainContentTabs
                :tabs="[
                    recinto && recinto.url_svg_asientos ? { tab: 'configurar-precios-desde-plano', nombre: 'Configurar precios desde el plano' } : null,
                    { tab: 'configurar-precios', nombre: 'Configurar precios' },
                    { tab: 'configurar-precios-regiones-anexas', nombre: 'Configurar precios regiones anexas' }
                ].filter(tab => tab !== null)"
                :initialTab="recinto && recinto.url_svg_asientos ? 'configurar-precios-desde-plano' : 'configurar-precios'"
            >

                <template slot="configurar-precios-desde-plano">
                    <TabPreciosDesdePlano :recinto="recinto" :tipos="tipos"/>
                </template>
                <template slot="configurar-precios">                            
                    <div>
                        <div>
                            <h3>Configurar precios</h3>
                        </div>
                        
                        <div>
                            <PreciosZonasComponent v-if="tipos" :tipos="tipos" :place_id="recinto.id" :esMovil="esMovil" />
                        </div>
                    </div>
                </template>
                <template slot="configurar-precios-regiones-anexas">                            
                    <div class="d-block d-md-flex align-items-center justify-content-between text-center">
                        <h5 class="m-0">Configurar precios de las regiones</h5>
                        <button
                            class="btn btn-primary mt-2 mt-md-0"
                            v-if="isZonaSeleccionada"
                            @click="unSelectZona"
                        >
                            Seleccionar otra región
                        </button>
                    </div>
                    
                    <div class="p-0 pt-3 pt-md-3">
                        <PreciosRegionesAnexasComponent
                            v-if="tipos"
                            :tipos="tipos"
                            :esMovil="esMovil"
                            :unSelectZonaItem="unSelectZonaItem"
                            @zonaIsSelected="isZonaSeleccionada = true"
                        />
                    </div>
                </template>
            </MainContentTabs>
        </template>
        <template #editarPrecio="{ index, tipo }">
            <EditPrecioModal :key="index + '-'" :precio="tipo" :lista_id="lista_id" @close="closeModal" />
        </template>
    </TablePricesComponent>
</template>

<script>
    import CargarPrecios from '../modals/CargarPrecios';
    import TabPreciosDesdePlano from './TabPreciosDesdePlano';
    import CreatePrecioModal from '../modals/CreatePrecioModal';
    import EditPrecioModal from '../modals/EditPrecioModal.vue';
    import TablePricesComponent from './components/TablePricesComponent';
    import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';
    import PreciosZonasComponent from '@/components/backend/abonos/precios/PreciosZonasComponent';
    import PreciosRegionesAnexasComponent from '@/components/backend/abonos/precios/PreciosRegionesAnexasComponent.vue';

    export default {
        data() {
            return {
                zonas: [],
                isZonaSeleccionada: false,
                unSelectZonaItem: 1,
                esMovil: false,
                reloadComponent: 1
            }
        },
        methods: {
            unSelectZona() {
                this.unSelectZonaItem++;
                this.isZonaSeleccionada = false;
            },
            onResize() {
                this.esMovil = window.innerWidth < 768;
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, creado) {
                this.$modal.hide(modal);

                if(creado) {
                    this.reloadComponent++;
                }
            }
        },
        computed: {
            lista_id() {
                return this.$store.getters.getListaAbonados.id;
            },
            listas() {
                return this.$store.getters.getListas.filter(lista => lista.activa == 0);
            },
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        beforeDestroy() {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        components: {
            TablePricesComponent, PreciosZonasComponent, MainContentTabs, TabPreciosDesdePlano, PreciosRegionesAnexasComponent, CargarPrecios, CreatePrecioModal, EditPrecioModal
        }
    }
</script>